import pt from 'prop-types';
import { Component as ReactComponent } from 'react';

import { SUBSCRIBE_CHANNEL } from './BreakpointRangeProvider';
import { BreakpointRangeValue } from './types';

interface BreakpointRangeHocState<B> {
    breakpointRange?: B;
}

export type BreakpointRangeProps<B = BreakpointRangeValue> = BreakpointRangeHocState<B>;
/**
 * Passes breakpoint ranges to component.
 *
 * Use functions in ./utils to compare breakpoint ranges.
 */
const withBreakpointRange = <P extends BreakpointRangeProps<B>, B = BreakpointRangeValue>(
    Component: React.ComponentType<P>
) =>
    class extends ReactComponent<Omit<P, 'breakpointRange'>, BreakpointRangeHocState<B>> {
        static contextTypes = {
            [SUBSCRIBE_CHANNEL]: pt.func,
        };

        private unsubscribe?: () => void;

        UNSAFE_componentWillMount() {
            this.unsubscribe = this.context[SUBSCRIBE_CHANNEL]((breakpointRange: B) =>
                this.setState({ breakpointRange })
            );
        }

        componentWillUnmount() {
            if (this.unsubscribe) {
                this.unsubscribe();
            }
        }

        render() {
            const props = {
                ...this.props,
                breakpointRange: this.state.breakpointRange,
            };

            return <Component {...(props as P)} />;
        }
    };

export default withBreakpointRange;
